import { DESKTOP_MIN_WIDTH, TABLET_MIN_WIDTH } from '~/constants/common';
import { RootState } from '~/store';

/**
 * @deprecated
 * Use theme from mui
 */
export const getWindowWidth = (state: RootState) => state.app.windowWidth;
/**
 * @deprecated
 * Use theme from mui
 */
export const getIsMobile = (state: RootState) => state.app.windowWidth < TABLET_MIN_WIDTH;
/**
 * @deprecated
 * Use theme from mui
 */
export const getIsDesktop = (state: RootState) => state.app.windowWidth >= DESKTOP_MIN_WIDTH;
/**
 * @deprecated
 * Use theme from mui
 */
export const getIsTablet = (state: RootState) =>
  state.app.windowWidth >= TABLET_MIN_WIDTH && state.app.windowWidth < DESKTOP_MIN_WIDTH;
